<template>
  <span class="title" v-if="$route.name === 'result'">{{getTitle()}}</span>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Title',
    computed: {
      ...mapState([
        'species',
        'filter'
      ])
    },
    methods: {
      getTitle() {
        return this.species.filter(species => species.id === this.filter.species)[0].name;
      }
    }
  }
</script>

<style scoped>

</style>